import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'

// Main Sections
import Clients from '../components/Clients'
import Training from '../components/Training/Training'
import Chats from '../components/Chats/Chats'
import NotFound from '../components/NotFound'

// Clients Subsections
import StoreClient from '../components/clients/StoreClient'
import UpdateClient from '../components/clients/UpdateClient'

// Intents
import Intents from '../components/Intents/Intents'
import StoreIntent from '../components/Intents/StoreIntent'
import UpdateIntent from '../components/Intents/UpdateIntent'

// Sentences
import SentencesAndAnswers from '../components/Intents/sentencesAndAnswers/SentencesAndAnswers'
import StoreSentence from '../components/Intents/sentencesAndAnswers/sentences/StoreSentence'
import UpdateSentence from '../components/Intents/sentencesAndAnswers/sentences/UpdateSentence'

// Common Answers
import CommonAnswers from '../components/Intents/sentencesAndAnswers/commonAnswers/CommonAnswers'
import StoreCommonAnswer from '../components/Intents/sentencesAndAnswers/commonAnswers/StoreCommonAnswer'
import UpdateCommonAnswer from '../components/Intents/sentencesAndAnswers/commonAnswers/UpdateCommonAnswer'

// Default Answers
import DefaultAnswers from '../components/Intents/sentencesAndAnswers/defaultAnswers/DefaultAnswers'
import StoreDefaultAnswer from '../components/Intents/sentencesAndAnswers/defaultAnswers/StoreDefaultAnswer'
import UpdateDefaultAnswer from '../components/Intents/sentencesAndAnswers/defaultAnswers/UpdateDefaultAnswer'

// Answers
import Answers from '../components/Intents/sentencesAndAnswers/answers/Answers'
import StoreAnswer from '../components/Intents/sentencesAndAnswers/answers/StoreAnswer'
import UpdateAnswer from '../components/Intents/sentencesAndAnswers/answers/UpdateAnswer'
import Auth from '../models/auth'

// Trainings
import AddKeywords from '../components/Training/AddKeywords'

// Chat details
import Chat from '../components/Chats/Chat'

// Kpis
import Kpis from '../components/Kpis'

import Xenio from '../models/xenio'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    /********************************************************************
     * MAIN SECTIONS
     ********************************************************************/
    {
      path: '/',
      redirect: 'clients'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/clients',
      name: 'Chatbots',
      component: Clients
    },
    {
      path: '/training',
      name: 'Entrenamiento',
      component: Training
    },
    {
      path: '/chats',
      name: 'Conversaciones',
      component: Chats
    },
    {
      path: '/kpis',
      name: 'KPIs',
      component: Kpis,
      meta: {
        hideDropdown: true
      }
    },
    /********************************************************************
     * CLIENTS
     ********************************************************************/
    {
      path: '/clients/store',
      name: 'Añadir cliente',
      component: StoreClient,
      meta: {
        admin: true
      }
    },
    {
      path: '/clients/:client(\\d+)/update',
      name: 'Editar cliente',
      component: UpdateClient,
      meta: {
        admin: true
      }
    },
    /********************************************************************
     * INTENTS
     ********************************************************************/
    {
      path: '/clients/:client(\\d+)/intents',
      name: 'Intenciones',
      component: Intents
    },
    {
      path: '/clients/:client(\\d+)/intents/store',
      name: 'Nueva Intención',
      component: StoreIntent
    },
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/update',
      name: 'Editar Intención',
      component: UpdateIntent
    },
    /********************************************************************
     * SENTENCES
     ********************************************************************/
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences',
      name: 'Frases y respuestas comunes',
      component: SentencesAndAnswers
    },
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences/store',
      name: 'Guardar Frase',
      component: StoreSentence
    },
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences/:sentence(\\d+)/update',
      name: 'Editar Frase',
      component: UpdateSentence
    },
    /********************************************************************
     * COMMON ANSWERS
     ********************************************************************/
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences/:sentence(\\d+)/common-answers',
      name: 'Mostrar Respuestas comunes',
      component: CommonAnswers
    },
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences/common-answers/store',
      name: 'Guardar Respuesta común',
      component: StoreCommonAnswer
    },
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences/common-answers/:answer(\\d+)/update',
      name: 'Actualizar Respuesta común',
      component: UpdateCommonAnswer
    },
    /********************************************************************
     * DEFAULT ANSWERS
     ********************************************************************/
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences/:sentence(\\d+)/default-answers',
      name: 'Mostrar Respuestas por defecto',
      component: DefaultAnswers
    },
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences/default-answers/store',
      name: 'Guardar Respuesta por defecto',
      component: StoreDefaultAnswer
    },
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences/default-answers/:answer(\\d+)/update',
      name: 'Actualizar Respuesta por defecto',
      component: UpdateDefaultAnswer
    },
    /********************************************************************
     * ANSWERS
     ********************************************************************/
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences/:sentence(\\d+)/answers',
      name: 'Mostrar Respuestas de una frase',
      component: Answers
    },
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences/:sentence(\\d+)/answers/store',
      name: 'Guardar Respuesta de una frase',
      component: StoreAnswer
    },
    {
      path: '/clients/:client(\\d+)/intents/:intent(\\d+)/sentences/:sentence(\\d+)/answers/:answer(\\d+)/update',
      name: 'Editar Respuesta',
      component: UpdateAnswer
    },
    /********************************************************************
     * TRAININGS
     ********************************************************************/
    {
      path: '/clients/:client(\\d+)/training',
      name: 'Entrenamiento de Chatbot',
      component: Training
    },
    {
      path: '/clients/:client(\\d+)/training/:training(\\d+)/keywords/:sentence(\\d+)',
      name: 'Añadir keywords',
      component: AddKeywords
    },
    /********************************************************************
     * CHATS
     ********************************************************************/
    {
      path: '/clients/:client(\\d+)/chats',
      name: 'Conversaciones de Chatbot',
      component: Chats
    },
    {
      path: '/chats/:chat(\\d+)',
      name: 'Conversación',
      component: Chat
    },
    /********************************************************************
     * KPIS
     ********************************************************************/
    {
      path: '/clients/:client(\\d+)/kpis',
      name: 'KPIS',
      component: Kpis
    },
    /********************************************************************
     * NOT FOUND
     ********************************************************************/
    {
      path: '/404',
      name: 'Página no disponible',
      component: NotFound
    },
    {
      path: '*',
      redirect: '404'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!Auth.getAuthorization() && to.path !== '/login') {
    console.log('redirigiendo a login...')
    router.push('login')
    return
  }
  if (!Auth.isAdmin() && to.meta.admin) {
    console.log('ruta no permitida...')
    router.push('clients')
    return
  }

  if (to.path !== '/login') {
    Xenio.show()
  } else {
    Xenio.hide()
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js